import React,{Component} from 'react';
import '../../App.css';
import Iframe from 'react-iframe';


class Product extends Component{

    render(){
        return(
          <div>
            
            <Iframe width="1343px" height="1000px" data-anvil-embed src="https://V4GAEDYI5SN2PEEL.anvil.app/7L3P77F3SBFXLDRSPWX7W3GJ"/>

          </div>
        );
    }
}

export default Product;
